import "core-js";
import "regenerator-runtime/runtime";
import eotwJSXFactory from "base/eotwJSXFactory";
import GlobalEvents from "base/GlobalEvents";

import "jquery-serializejson";
import Page from "webPage/Page";
import handleOnPageNavigationBlocks, { scrollTo } from "blocks/handleOnPageNavigationBlock";
import handleBlogGalleryBlocks from "blocks/handleBlogGalleryBlocks";
import handleConsultantSearchBlocks from "blocks/handleConsultantSearchBlocks";
import { handleNavSearch } from "util/nav-search";
import { handleNewsletterForms } from "util/handleNewsletterForms";
import handleGoogleMapBlocks from "blocks/handleGoogleMapBlocks";
import handleTestimonialsSliderBlocks from "blocks/handleTestimonialsSliderBlocks";
import handleConsultantsSliderBlocks from "blocks/handleConsultantsSliderBlocks";
import handleConsultantsListBlocks from "blocks/handleConsultantsListBlocks";
import handleConsultantsHeaderSliderBlocks from "blocks/handleConsultantsHeaderSliderBlocks";
import handleAccordionBlocks from "blocks/handleAccordionBlocks";
import handleManagementTeamBlocks from "blocks/handleManagementTeamBlocks";
import { handleNavigations } from "util/handleNavigations";
import handleSubpageNavigations from "./blocks/handleSubpageNavigations";

$(function () {
    let $body = $('body');
    let $windowWidth = $(window).outerWidth();
    let mediumBreakpoint = 1280;

    if (window.jsLoadTimeout) {
        clearTimeout(window.jsLoadTimeout);
    }

    Page.init();

    $body.on('click', 'a[href]', function () {
        let $this = $(this);

        if ($this.is('.js-no-scroll')) {
            return;
        }

        let url = new URL($this.attr('href'));

        if (url.pathname !== '/enquire-online/') {
            return;
        }

        if ($('#gform_wrapper_1').length === 0) {
            return;
        }

        scrollTo('#gform_wrapper_1');
        return false;
    }).on("click", ".js-toggle-mobile-accordion", function () {
        $(this).parents(".mobile-accordion").toggleClass("mobile-accordion--active").find(".mobile-accordion__body").stop().slideToggle();
    }).on('click', '.js-toggle-mobile', function () {
        $body.toggleClass('mobile-menu-active');
        $body.removeClass('body-search-active');
        $('html').toggleClass('html-mobile-menu-active');
        $('.nav-dropdown--active').removeClass('nav-dropdown--active');
        $('.nav__link--dropdown-active').removeClass('nav__link--dropdown-active');

    }).on('mouseenter focus', '.js-consultant-item', function () {
        if ($windowWidth >= mediumBreakpoint) {
            let padding_value = 12;
            let total_width = $(this).find('.image-slide__text').outerWidth() + $(this).find('.image-slide__image').outerWidth() + padding_value;
            $(this).css({'width': total_width + 'px'});
        }
    }).on('mouseleave blur', '.js-consultant-item', function () {
        $(this).attr('style', '');
    }).on('click', '.js-scroll-to', function () {
        scrollTo($(this).attr('href'));
        return false;
    });

    handleTestimonialsSliderBlocks();
    handleConsultantsSliderBlocks();
    handleOnPageNavigationBlocks();
    handleBlogGalleryBlocks();
    handleConsultantSearchBlocks();
    handleNavSearch();
    handleNewsletterForms();
    handleGoogleMapBlocks();
    handleConsultantsHeaderSliderBlocks();
    handleConsultantsListBlocks();
    handleAccordionBlocks();
    handleManagementTeamBlocks();
    handleNavigations();
    handleSubpageNavigations();
});

window.eotwJSXFactory = eotwJSXFactory;
window.GlobalEvents = GlobalEvents;
